export default [
  {
    'title': 'Nuts',
    'collection': 'pwf_nuts',
    'link': '/nuts'
  },
  {
    'title': 'Dried Fruits',
    'collection': 'pwf_driedfruits',
    'link': '/dried-fruits'
  },
  {
    'title': 'Seeds',
    'collection': 'pwf_seeds',
    'link': '/seeds'
  },
  {
    'title': 'Lentils Beans & Pulses',
    'collection': 'pwf_lentilsbeansandpulses',
    'link': '/lentils-beans-pulses'
  },
  {
    'title': 'Grains',
    'collection': 'pwf_grains',
    'link': '/grains'
  },
  {
    'title': 'Cereals and Muesli',
    'collection': 'pwf_cerealsandmuesli',
    'link': '/cereals-and-muesli'
  },
  {
    'title': 'Minerals & Salts',
    'collection': 'pwf_mineralsandsalts',
    'link': '/minerals-salts'
  },
  {
    'title': 'Flours',
    'collection': 'pwf_flours',
    'link': '/flours'
  },
  {
    'title': 'Drinks',
    'collection': 'pwf_drinks',
    'link': '/drinks'
  },
  {
    'title': 'Rice',
    'collection': 'pwf_rice',
    'link': '/rice'
  },
  {
    'title': 'Vitamins',
    'collection': 'pwf_vitamins',
    'link': '/vitamins'
  },
  {
    'title': 'Pantry',
    'collection': 'pwf_pantry',
    'link': '/pantry'
  },
  {
    'title': 'Healthy Snacks',
    'collection': 'pwf_healthysnacks',
    'link': '/healthy-snacks'
  },
  {
    'title': 'Pickes and Fermented',
    'collection': 'pwf_picklesandfermented',
    'link': '/pickes-and-fermented'
  },
  {
    'title': 'Cacao',
    'collection': 'pwf_cacao',
    'link': '/cacao'
  },
  {
    'title': 'Superfoods',
    'collection': 'pwf_superfoods',
    'link': '/superfoods'
  },
  {
    'title': 'Herbs and Spices',
    'collection': 'pwf_herbsandspices',
    'link': '/herbs-and-spices'
  },
  {
    'title': 'Oil',
    'collection': 'pwf_oil',
    'link': '/oil'
  },
  {
    'title': 'Plant Based Proteins',
    'collection': 'pwf_plantbasedproteins',
    'link': '/plant-based-proteins'
  },
  {
    'title': 'Coffee',
    'collection': 'pwf_coffee',
    'link': '/coffee'
  },
  {
    'title': 'Vinegar',
    'collection': 'pwf_vinegar',
    'link': '/vinegar'
  },
  {
    'title': 'Baking & Cooking',
    'collection': 'pwf_bakingcooking',
    'link': '/baking-cooking'
  }
]
